<template>
  <div class="carousel">
    <div class="carousel-container">
      <div class="carousel-track" :style="trackStyle">
        <div v-for="(image, index) in images" :key="index" class="carousel-item">
          <img :src="image" :alt="'Product ' + (index + 1)" />
        </div>
      </div>
    </div>
    <button class="carousel-prev" @click="prev">&lt;</button>
    <button class="carousel-next" @click="next">&gt;</button>
  </div>
</template>

<script>
import product1 from '@/assets/Product-1.jpg'
import product2 from '@/assets/Product-2.jpg'
import product3 from '@/assets/Product-3.jpg'
import product4 from '@/assets/Product-4.jpg'
import product5 from '@/assets/Product-5.jpg'
import product6 from '@/assets/Product-6.jpg'

export default {
  name: 'ProductCarousel',
  props: {
    // 可以接受外部传入的图片数组
    productImages: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      currentIndex: 0,
      autoPlayInterval: null,
      defaultImages: [product1, product2, product3, product4, product5, product6]
    }
  },
  computed: {
    // 使用传入的图片或默认图片
    images() {
      return this.productImages || this.defaultImages;
    },
    // 根据视口宽度决定显示几个项目
    itemPercentage() {
      return window.innerWidth <= 768 ? 100 : 25;
    },
    // 更新轮播图滑动样式
    trackStyle() {
      return {
        transform: `translateX(-${this.currentIndex * this.itemPercentage}%)`
      }
    }
  },
  methods: {
    next() {
      if (this.currentIndex < this.images.length - (100/this.itemPercentage)) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.images.length - (100/this.itemPercentage);
      }
    },
    // 启动自动播放
    startAutoPlay() {
      this.autoPlayInterval = setInterval(this.next, 5000);
    },
    // 停止自动播放
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }
    },
    // 处理窗口大小变化
    handleResize() {
      this.currentIndex = 0; // 重置位置避免布局问题
    }
  },
  mounted() {
    this.startAutoPlay();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    this.stopAutoPlay();
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin: 30px 0;
}

.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  flex: 0 0 25%;
  min-width: 25%;
  padding: 0 10px;
}

.carousel-item img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  aspect-ratio: 16/9;
}

.carousel-prev,
.carousel-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-prev {
  left: 10px;
}

.carousel-next {
  right: 10px;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .carousel-item {
    flex: 0 0 100%;
    min-width: 100%;
  }
}
</style>